(function () {
    'use strict';

    angular
        .module('rms.common')
        .controller('ListFilterSaveViewFormCtrl', ListFilterSaveViewFormCtrl);

    function ListFilterSaveViewFormCtrl(close, $timeout, dialogOptions) {
        const vm = this;
        vm.name = dialogOptions.viewName;
        vm.share = dialogOptions.shareWithAll;
        vm.shared_visibility = dialogOptions.shareToEveryoneVisibility;
        if(dialogOptions.title){
            vm.options = {
                'title': dialogOptions.title
            };
        }
        vm.dismiss = function() {
            close(false);
        };

        vm.saveView = function() {
            if (!(vm.name.length > 0)) {
                vm.hasError = true;
                return;
            }
            close({
                'saved_view_name': vm.name, 
                'shared_with_all': vm.share
            });
        };

        $timeout( function () {
            vm.show = true;
        } );
    }
})();